import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const VerifiedPill = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
  const pillRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (!showTooltip) return;
    const handleClickOutside = (e) => {
      if (
        pillRef.current && !pillRef.current.contains(e.target) &&
        tooltipRef.current && !tooltipRef.current.contains(e.target)
      ) {
        setShowTooltip(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showTooltip]);

  const handleClick = (e) => {
    e.stopPropagation();
    if (!showTooltip && pillRef.current) {
      const rect = pillRef.current.getBoundingClientRect();
      // Position below the pill
      setTooltipPos({
        top: rect.bottom + 10 + window.scrollY,
        left: rect.left + rect.width / 2 + window.scrollX,
      });
    }
    setShowTooltip(prev => !prev);
  };

  return (
    <>
      <div
        ref={pillRef}
        onClick={handleClick}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          background: 'linear-gradient(135deg, #34d399 0%, #059669 100%)',
          padding: '6px 12px',
          borderRadius: '20px',
          color: 'white',
          fontWeight: '600',
          fontSize: '0.875rem',
          boxShadow: '0 2px 4px rgba(5, 150, 105, 0.25)',
          marginLeft: '12px',
          verticalAlign: 'middle',
          cursor: 'pointer',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <path d="M9 12l2 2 4-4"/>
        </svg>
        <span>Verified Pro</span>
      </div>

      {showTooltip && createPortal(
        <div
          ref={tooltipRef}
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'absolute',
            top: tooltipPos.top,
            left: tooltipPos.left,
            transform: 'translateX(-50%)',
            background: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '10px',
            padding: '12px 16px',
            width: '280px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            zIndex: 10001,
            textAlign: 'left',
            lineHeight: '1.4',
          }}
        >
          {/* Arrow pointing up */}
          <div style={{
            position: 'absolute',
            top: '-6px',
            left: '50%',
            transform: 'translateX(-50%) rotate(45deg)',
            width: '12px',
            height: '12px',
            background: 'white',
            borderLeft: '1px solid #e5e7eb',
            borderTop: '1px solid #e5e7eb',
          }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" fill="#059669" />
              <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span style={{ fontWeight: 700, fontSize: '0.85rem', color: '#047857' }}>Verified Professional</span>
          </div>
          <p style={{ margin: 0, fontSize: '0.8rem', color: '#475569', fontWeight: 400 }}>
            This business has passed our strict background checks, including ABN and trade license verification. You can hire them with confidence.
          </p>
        </div>,
        document.body
      )}
    </>
  );
};

export default VerifiedPill;
